module.exports = __webpack_public_path__ + "img/v4_trade_bg1.b6c84f2a.png";